export default __webpack_public_path__ + "static/media/step4-min.64c31c9a.webp";